import moment from "moment";
import React from "react";
import styled from "styled-components";
import {
  MESSAGE_IMAGE_PATH_ADMIN,
  MESSAGE_IMAGE_PATH_USER
} from "../../config";
import { IMessage } from "../../interfaces";

interface IProps {
  children: React.ReactNode;
  messages: IMessage[];
  dateText: (message: IMessage, index: number) => string;
}

const MessageList: React.FC<IProps> = ({ children, messages, dateText }) => {
  return (
    <React.Fragment>
      <MessageLists>
        {messages.map((message: IMessage, index: number) => {
          const date = dateText(message, index);
          const time = moment(message.timestamp);
          return (
            <React.Fragment key={message.id}>
              {date !== "" && (
                <DateWrapper>
                  <DateContent>{date}</DateContent>
                </DateWrapper>
              )}
              <div
                key={message.id}
                className={`talk-page__message talk-page__message--${message.sender}`}
              >
                {(message.dataType === "text" ||
                  message.dataType === "other") && (
                  <div className="talk-page__message__text">
                    {message.value.split("\n").map((item, key) => (
                      <React.Fragment key={key}>
                        {item}
                        <br />
                      </React.Fragment>
                    ))}
                  </div>
                )}
                {message.dataType === "image" && (
                  // MEMO: message.adminだとadminからの初回upload時にfalseとなり、画像が表示されない。
                  <ImgMessage
                    src={
                      (message.sender === "admin"
                        ? MESSAGE_IMAGE_PATH_ADMIN
                        : MESSAGE_IMAGE_PATH_USER) + message.value
                    }
                  />
                )}
                <MessageTime>
                  {time.format("H:mm")}({message.admin && message.admin.name})
                </MessageTime>
              </div>
            </React.Fragment>
          );
        })}
      </MessageLists>
      <div>{children}</div>
    </React.Fragment>
  );
};

const MessageLists = styled.div`
  padding: 0 16px 12px;
  // headerとfooter分の高さをマイナス
  min-height: calc(100vh - 65px - 52px);
`;

const DateWrapper = styled.div`
  text-align: center;
  padding: 16px 0;
`;

const DateContent = styled.div`
  display: inline-block;
  background-color: rgba(85, 85, 85, 0.35);
  color: #fff;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.5rem;
`;

const ImgMessage = styled.img`
  max-width: 60%;
  border-radius: 8px;
  box-shadow: 1px 1px 3px 0px rgba(85, 85, 85, 0.5);
`;

const MessageTime = styled.div`
  font-size: 0.5rem;
  margin: 4px 6px;
  opacity: 0.8;
`;

export default MessageList;
